import { render, staticRenderFns } from "./floorClassBook.vue?vue&type=template&id=f1c9386c&scoped=true"
import script from "./floorClassBook.vue?vue&type=script&lang=js"
export * from "./floorClassBook.vue?vue&type=script&lang=js"
import style0 from "./floorClassBook.vue?vue&type=style&index=0&id=f1c9386c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c9386c",
  null
  
)

export default component.exports